/**
 * `ClockPort` implementation backed by the system clock (ADR-0006).
 *
 * This is the ONLY place in the client that is allowed to call `Date.now()`
 * / `new Date()` directly outside of tests -- everything under `src/domain`
 * receives `today`/`now` through the injected port instead (ADR-0001 rule 2).
 */

import type { ClockPort, IsoDate, IsoDateTime } from '../../contracts';

export function createSystemClockPort(): ClockPort {
  return {
    today(): IsoDate {
      return toIsoDate(new Date());
    },
    now(): IsoDateTime {
      return new Date().toISOString() as IsoDateTime;
    },
  };
}

function toIsoDate(date: Date): IsoDate {
  const year = date.getFullYear().toString().padStart(4, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}` as IsoDate;
}
